module.exports = __webpack_public_path__ + "img/lichtgestalten.65535417.png";